import { InputAdornment } from "@mui/material";
import { faRotate, faSquarePlus, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAppSelector } from "@/store/hooks";
import { selectPromptList } from "@/store/qas/qasPromptSlice";
import { useAccessRight, useTranslate } from "@/hooks";
import { QAS } from "@/constants/accessRights";
import { colorPrimary, colorRed } from "@/constants/colors";
import { Hint } from "@/HOC";
import { IInputAdornmentProps } from "./InputAdornment.props";
import styles from "./InputAdornment.module.scss";

const CustomInputAdornment = ({
	idxPhrase,
	phrase,
	arrayPhrases,
	inputPhrase,
	setSelectButtonType,
	setAnchorForParaphrase,
	setAnchorForButtonForm,
	paraphraseHandler,
	sayOrConfirmationActionDataChangeHandler,
}: IInputAdornmentProps): JSX.Element => {
	const promptList = useAppSelector(selectPromptList); // store - список промптов

	const isAccess = useAccessRight(); // hook для проверки прав доступа
	const translate = useTranslate(); // hook для перевода текста

	// обработчик открытия окна перефразирования
	const paraphraseWindowOpenHandler = (e: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
		setAnchorForParaphrase(e.currentTarget);
		// когда нет промптов или всего один - запускаем сразу
		if (promptList.data === null || (Array.isArray(promptList.data) && promptList.data.filter((promptItem) => promptItem.type === "similars_generator").length <= 1)) {
			paraphraseHandler(promptList.data?.filter((promptItem) => promptItem.type === "similars_generator")[0]?.id);
		}
	};

	return (
		<InputAdornment position="end">
			<div className={styles.popupButtonBlock} onMouseDown={(e) => e.preventDefault()} data-popup-button-block="">
				{/* добавить кнопку */}
				<Hint hint={translate("hint_addButton")} position="top">
					<div
						onClick={(e) => {
							setSelectButtonType(phrase.includes("sendcontact") || phrase.includes("sendgeo") ? "sendgeo" : "button");
							setAnchorForButtonForm(e.currentTarget);
						}}
					>
						<FontAwesomeIcon icon={faSquarePlus} color={colorPrimary} size="sm" title={translate("button_addButton")} style={{ cursor: "pointer" }} />
					</div>
				</Hint>
				{/* перефразировать */}
				{isAccess(QAS.PARAPHRASE) && inputPhrase !== "" && (
					<Hint hint={translate("hint_rephrase")} position="top">
						<div onClick={paraphraseWindowOpenHandler}>
							<FontAwesomeIcon icon={faRotate} color={colorPrimary} size="sm" title={translate("button_rephrase")} style={{ cursor: "pointer" }} />
						</div>
					</Hint>
				)}
				{/* удалить фразу */}
				{arrayPhrases.length > 1 && arrayPhrases.length !== idxPhrase && (
					<div>
						<FontAwesomeIcon
							icon={faTrashCan}
							color={colorRed}
							size="sm"
							onClick={() => sayOrConfirmationActionDataChangeHandler({ operation: "delete" })}
							title={translate("button_deletePhrase")}
							style={{ cursor: "pointer" }}
						/>
					</div>
				)}
			</div>
		</InputAdornment>
	);
};

export default CustomInputAdornment;
